import React from 'react';
import { NextSeo } from 'next-seo';
import { serialActions, asyncActions } from '@docavenue/core';
import { get } from 'lodash';
import { cardsActions } from '@/src/actions';
import HcdRDVMobile from '@/components/templates/HcdRDVMobile/HcdRDVMobile';
import { useIsPartners } from '@/src/hooks/useIsPartners';
import HcdRDVPartners from '@/components/templates/HcdRDVPartners/HcdRDVPartners';
import { wrapper } from '@/src/store';

const HcdRDV = () => {
  const isPartners = useIsPartners();

  return (
    <>
      <NextSeo noindex nofollow />
      {isPartners ? <HcdRDVPartners /> : <HcdRDVMobile />}
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async ({
    query: { speciality, locality, slug: fullName, centerId },
  }) => {
    const url = `/${speciality}/${locality}/${fullName}`;

    try {
      await asyncActions(
        store.dispatch,
        serialActions.serial([
          () => cardsActions.reset(),
          () =>
            cardsActions.getList({
              url,
            }),
          state => {
            const cards = get(state, 'cards.items', []);
            const card =
              cards.find(item => item.center.id === centerId) || cards[0];
            return cardsActions.setItem(card);
          },
        ]),
      );
      return { props: {} };
    } catch (e) {
      const { error, context } = e as {
        error: { data?: { location?: string }; code: string };
        context: { index: number };
      };

      if (context?.index === 1 && error?.code === 'REDIRECT') {
        const newLocation = error?.data?.location;
        if (newLocation) {
          return {
            redirect: {
              destination: `${newLocation}/rdv${
                centerId ? `?centerId=${centerId}` : ''
              }`,
              permanent: true,
            },
          };
        }
      }
      throw e;
    }
  },
);

export default HcdRDV;
